const images = [
    {
        title: "kyanbels",
        censor: "https://sbucket.harumi.io.vn/kyanbels.jpg",
        uncensor: "https://sbucket.harumi.io.vn/mchodoicailozj.webp",
    },
    {
        title: "hen",
        censor: "https://sbucket.harumi.io.vn/imagsdfe.png",
        uncensor: "https://sbucket.harumi.io.vn/dee-dee-chuppy.png",
    },
]

export default images
